<!-- 资源-查看视频弹窗-吴影茹 -->
<template>
  <OyModal v-model:open="modalVisible" title="查看视频" :width="800" @cancel="cancelHandler" :customFooter="true">
    <div v-if="modalVisible">
      <div v-show="!isError">
        <video
          id="videobox"
          ref="videoRef"
          class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9 video_content"
          width="100%"
          preload="auto"
          :autoplay="true"
        >
          <p class="vjs-no-js">不支持播放</p>
        </video>
      </div>
      <div v-show="isError" class="errorTip">
        <p style="color: white">视频出错了！</p>
      </div>
    </div>
    <template #footer>
      <a-button @click="cancelHandler">关 闭</a-button>
    </template>
  </OyModal>
</template>
                    
<script setup lang="ts">
import { onMounted, ref, getCurrentInstance, nextTick, watch } from 'vue'
import videojs from 'video.js'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  url: {
    type: String,
    default: ''
  }
})

onMounted(() => {})
const emit = defineEmits(['update:visible'])

const modalVisible = ref<boolean>(false)

// 播放器
const isError = ref(false)
const videoRef = ref<any>(null)
const player = ref()

/* 初始化视频播放器 */
const init = () => {
  var index = props.url.lastIndexOf('.')
  var text = props.url.substring(index + 1)
  if (text != 'mp4' && text != 'webm' && text != 'ogg') {
    isError.value = true
  } else {
    player.value = videojs(
      videoRef.value,
      {
        //视频源
        sources: [{ src: props.url }],
        //是否显示播放按钮
        bigPlayButton: true,
        playbackRates: [0.5, 1, 1.5, 2],
        controls: true,
        //设置小喇叭音量键
        controlBar: {
          fullscreenToggle: true,
          // 音量条的横向还是纵向显示
          volumePanel: {
            inline: false
          }
        }
      },
      () => {
        player.value.on('play', () => {})
      }
    )
  }
}

watch(
  () => props.visible,
  (newVal) => {
    modalVisible.value = newVal
    if (newVal) {
      setTimeout(() => {
        init()
      }, 200)
    }
  },
  { immediate: true }
)

// 关闭
const cancelHandler = () => {
  emit('update:visible', false)
}
</script>
                    
<style lang="scss" scoped>
.video_content {
  width: 100%;
  height: 100%;
}
</style>